import { OperationProps } from "@/types/operation";

const buildPropsList = (props: OperationProps) => {
  const stringifiedProps = props.map(([k, v]) => `${k}:${v}`).join(" ");

  return `(${stringifiedProps})`;
};

export default buildPropsList;
